import { BreadcrumpComponent } from "../components/subcomponents/BreadcrumpCompont";
import { PageSectionHeader } from "../components/subcomponents/PageSectionHeader";
import bigCover from '../assets/images/big-cover.jpg';
import { useState, useEffect } from "react";
import { apiGet } from "../utils/api";
import { Colors } from "../utils/utils.colors";

type Partner = {
  id: number;
  name: string;
  logo: string | null;
  url: string | null;
  description: string | null;
  sortOrder: number;
  isActive: boolean;
};

export const Partners: React.FC = () => {
  const [partners, setPartners] = useState<Partner[]>([]);

  useEffect(() => {
    apiGet("/partners", { activeOnly: "true" })
      .then((res: any) => res?.rows && setPartners(res.rows))
      .catch(() => {});
  }, []);

  return (
    <>
      <BreadcrumpComponent
        title="Nos partenaires"
        subtitle="L'ULPGL collabore avec des institutions académiques, des organisations internationales, des entreprises et des organismes gouvernementaux pour offrir une formation de qualité et contribuer au développement de la région des Grands Lacs."
        imageCover={bigCover}
      />

      <div className="padding-x site-content" style={{ paddingTop: '3rem', paddingBottom: '4rem' }}>
        <main className="wp-block-group alignfull has-global-padding is-layout-constrained wp-block-group-is-layout-constrained">
          <PageSectionHeader
            eyebrow="Collaborations"
            title="Ils nous accompagnent"
            lead="Découvrez les organisations et institutions qui soutiennent l'ULPGL dans sa mission de formation et de recherche."
            align="center"
          />

          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
            gap: '2rem',
            marginTop: '2rem',
          }}>
            {partners.length === 0 ? (
              <p style={{ textAlign: 'center', width: '100%', color: '#999' }}>Aucun partenaire pour le moment.</p>
            ) : (
              partners.map((p) => (
                <div
                  key={p.id}
                  style={{
                    background: '#fff',
                    borderRadius: 12,
                    boxShadow: '0 2px 12px rgba(0,0,0,0.06)',
                    padding: '2rem 1.5rem',
                    textAlign: 'center',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: '1rem',
                    border: '1px solid #eee',
                  }}
                >
                  {p.logo ? (
                    <img src={p.logo} alt={p.name} style={{ height: 80, objectFit: 'contain', maxWidth: '100%' }} />
                  ) : (
                    <div
                      style={{
                        width: 80, height: 80, borderRadius: '50%',
                        background: Colors.primaryColor,
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        color: '#fff', fontSize: 28, fontWeight: 700,
                      }}
                    >
                      {p.name.charAt(0)}
                    </div>
                  )}
                  <h3 style={{ fontSize: 16, fontWeight: 700, color: '#222', margin: 0 }}>{p.name}</h3>
                  {p.description && (
                    <p style={{ fontSize: 13, color: '#666', lineHeight: 1.6, margin: 0 }}>{p.description}</p>
                  )}
                  {p.url && (
                    <a
                      href={p.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        display: 'inline-block', marginTop: '0.5rem',
                        fontSize: 13, color: Colors.primaryColor, fontWeight: 600,
                        textDecoration: 'none', borderBottom: `2px solid ${Colors.primaryColor}`,
                      }}
                    >
                      Visiter le site →
                    </a>
                  )}
                </div>
              ))
            )}
          </div>
        </main>
      </div>
    </>
  );
};
